export default __webpack_public_path__ + "media/order.195cf538.mp3";